"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEqualSigns = exports.addEqualSigns = void 0;
/**
 * Dodaje jeden lub dwa znaki równości na podstawie długości wejściowego stringa (dostosowane do
 *  reguł kodowania base64 i podzielności przez 4)
 * @param {string} base64Input  Wejściowy string (intencjonalnie: zakodowany w base64)
 */
var addEqualSigns = function (base64Input) {
    var input = base64Input;
    var remainder = base64Input.length % 4;
    if (remainder) {
        input += remainder === 2 ? '==' : '=';
    }
    return input;
};
exports.addEqualSigns = addEqualSigns;
/**
 * Usuwa znaki równości z końca stringa
 * @param {string} input  Konwertowany string
 */
var removeEqualSigns = function (input) { return input.replace(/=+$/, ''); };
exports.removeEqualSigns = removeEqualSigns;
